
export const PromotionsPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Promotional Tools</h1>
      <div className="text-muted-foreground">
        Manage email campaigns, affiliate links, and social media integration.
      </div>
    </div>
  );
};
